<template>
  <span class="animated-value" :class="className">{{
    isNaN(animatedNumber) && animatedNumber !== undefined ? (animatedNumber.slice(-1) !== '%' ? 0 : animatedNumber) : animatedNumber
  }}</span>
</template>

<script>
import TweenLite from 'gsap';
export default {
  props: ['value', 'toFixedValue', 'duration', 'className'],

  data() {
    return {
      tweenedNumber: this.value,
    };
  },

  computed: {
    animatedNumber() {
      return isNaN(this.tweenedNumber) ? this.value : parseFloat(this.tweenedNumber).toFixed(this.toFixedValue || 0);
    },
  },

  watch: {
    value(newValue) {
      if (!isNaN(this.tweenedNumber)) {
        TweenLite.to(this.$data, this.duration ? this.duration : 1.0, { tweenedNumber: newValue });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

span {
  color: inherit;
  transition: color 0.3s ease;
}
</style>

<style lang="scss">
@use '@/styles/colors.scss';

.exporting .animated-value {
  transition: 0s;

  &.green {
    color: colors.$green-color;
  }
  &.orange {
    color: colors.$warning-color;
  }
  &.red {
    color: colors.$red-color;
  }
}
</style>
